<template>
  <van-config-provider theme="dark">
    <div id="app" class="app" :class="{ 'pcd-home-shell': usesForestUi }">
      <router-view class="router-view"></router-view>
      <DataStatus v-if="!usesForestUi" />
      <!-- 固定在底部的導航 -->
      <div class="bottom-tab-wrap">
      <BottomTab :forest="usesForestUi" />
      </div>
    </div>
  </van-config-provider>
</template>

<script setup>
import { legacyBusy, startLegacyAdmission } from '@/legacy/admission';
import { useAccountOperationLock } from '@/composables/accountOperationLock';
useAccountOperationLock(legacyBusy);
import DataStatus from '@/components/DataStatus.vue';
import BottomTab from '@/components/BottomTab.vue';
import { useRoute } from 'vue-router';
import { onMounted, onBeforeUnmount, ref, watch, computed } from 'vue';
import { useWalletStore } from '@/stores/walletStore';
import { bindWalletRecovery } from '@/composables/walletRecovery';
import { useWalletAccount } from '@/composables/useWalletAccount';

const route = useRoute();
const usesForestUi = computed(() => route.meta.forest || ['/', '/wallet', '/mine', '/buy-pine', '/invite'].includes(route.path));
const walletStore = useWalletStore();
const accountData = useWalletAccount();

const showConnectBtn = ref(false);

function isDesktop() {
  const ua = navigator.userAgent.toLowerCase();
  // 常見移動端關鍵字
  return !(/android|iphone|ipad|ipod|mobile|windows phone|blackberry|opera mini|mqqbrowser|micromessenger|webos|ucbrowser|symbian/.test(ua));
}

// 最現代、最穩定的監聽方式
watch(() => accountData.value.address, (val) => {
  console.log('[App.vue] address 變化:', val);
  if (val) {
    walletStore.fetchAllData(true, val);
  }else{
    walletStore.resetAccountData();
  }
}, { immediate: true });

watch(() => accountData.value.chainId, chain => {
  if (chain === 137) walletStore.connectionError = '';
});

let stopRecovery, stopLegacy;
onBeforeUnmount(() => { stopRecovery?.(); stopLegacy?.(); });
onMounted(async () => {
  stopLegacy = startLegacyAdmission(() => import('@/legacy/recovery').then(module => module.recoverLegacy()).catch(() => {}));
  stopRecovery = bindWalletRecovery(() => walletStore.smartConnectWallet());
  console.log('[App.vue] onMounted');
  showConnectBtn.value = isDesktop();
  await walletStore.smartConnectWallet();
});
</script>

<style src="./styles/default.css"></style>
<style src="./styles/pcd-i18n.css"></style>
<style>
.app {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.router-view {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 60px; /* 預留底部導航空間 */
  scroll-behavior: smooth;
}

.bottom-tab-wrap {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  z-index: 9999;
  background: transparent;
}
</style>